export enum BlockDataAttributes {
  InterfacePageId = 'data-interface-page-id',
  PageScopeKey = 'data-page-scope-key',
  PageId = 'data-page-id',
  BlockId = 'data-block-id',
  BlockType = 'data-block-type',
  BlockVariant = 'data-block-variant',
  DataColorSchema = 'data-color-scheme',
  BlockRunTimeBlockId = 'data-block-runtime-block-id',
  BlockPositionInParent = 'data-block-pos',
  BlockVersion = 'data-block-version',
  // Marks the slot-root Stack on the consumer canvas. Canvas hover/click
  // uses this to break out of the module-wrapper resolution when the click
  // target sits inside a slot subtree — otherwise the enclosing TC would
  // steal selection from the consumer's slot children. See
  // useInterfaceBuilderActions#getBlockId.
  SlotRoot = 'data-slot-root',
  // Marks the root of a contextual-dialog's portaled content, valued with the
  // interface-page id its content belongs to. The dialog is portaled out of the
  // module/page DOM subtree, so the page-scoped canvas resolution can't tell
  // which page the clicked block lives on. The resolver compares this value to
  // the active page: same page (dialog placed directly on the active page) →
  // resolve the clicked block normally; different page (dialog inside a module,
  // or a page-variant dialog embedding another page) → bail so selection stays
  // put. See useInterfaceBuilderActions#getBlockId.
  ContextualDialogRoot = 'data-contextual-dialog-root',
  // Addresses a sub-element inside a block (eg. one table cell) so an action fired from it can
  // anchor to it rather than to the whole block. Stamped by the block that owns the sub-element,
  // and only ever read back by getTargetBlockElement.
  BlockAnchorId = 'data-block-anchor-id',
}
